export default __webpack_public_path__ + "static/media/alarm-no.84e074dd.svg";